import Topics from './topics.js';
import Member from './member.js';
import Contact from './contact.js';
import * as Util from './util.js';

class Top
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Top
	// ---------------------------------------------------------------------------------------------------------

  constructor(){

    //コンポーネント生成
    this.topics = new Topics();
    this.member = new Member();
    this.contact = new Contact();
  }

  /**
   * スタート
   */
  start(){

    //トピックススタート
    this.topics.start();

    //スクロールのハンドリング
    $(window).scroll(this.onScroll.bind(this));
    this.onScroll();

    //ループ処理
    this.loop();
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	スクロールハンドリング
	// ---------------------------------------------------------------------------------------------------------

  /**
   * スクロール
   */
  onScroll(e){

    //イントロアップデート
    this.updadeIntro();

    //イントロ背景アップデート
    this.updadeIntroBg();
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	スクロールハンドリング
	// ---------------------------------------------------------------------------------------------------------

  loop(){

    //WORKS一覧のアップデート
    this.updateWorks();

    //loop
    requestAnimationFrame( () => {
      this.loop();
    });
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	イントロ関連
	// ---------------------------------------------------------------------------------------------------------

  /**
   * アップデート
   */
  updadeIntro(){

    //参照
    const copy1 = $(".p-top__introContents-copy1");

    //inViewチェック
    if(!copy1.hasClass("isInView"))
    {
      const scrollY = $(window).scrollTop();
      const bottomY = copy1.offset().top - $(window).height() + copy1.outerHeight();

      //INVIEW
      if(scrollY > bottomY)
      {
        copy1.addClass("isInView");
        this.showIntro();
      }
    }
  }

  /**
   * 表示
   */
  showIntro(){

    //参照
    const copy1 = $(".p-top__introContents-copy1");
    const copy2 = $(".p-top__introContents-copy2");
    const body = $(".p-top__introContents").find(".body");
    const bg = $(".p-top__introBg");

    //コピー１表示
    TweenMax.delayedCall(0.0, ()=>{
      copy1.addClass("enter");
    });
    TweenMax.delayedCall(0.6, ()=>{
      copy1.addClass("show");
    });

    //コピー２表示
    TweenMax.delayedCall(0.2, ()=>{
      copy2.addClass("enter");
    });
    TweenMax.delayedCall(0.8, ()=>{
      copy2.addClass("show");
    });

    //body表示
    TweenMax.delayedCall(0.4, ()=>{
      body.addClass("enter");
    });
    TweenMax.delayedCall(1.0, ()=>{
      body.addClass("show");
    });

    // //背景表示
    // TweenMax.delayedCall(0.6, ()=>{
    //   bg.addClass("showFirst");
    // });
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	イントロ背景
	// ---------------------------------------------------------------------------------------------------------

  /**
   * アップデート
   */
  updadeIntroBg(){

    //参照
    const wrapper = $(".p-top__introWrapper");
    const bg = $(".p-top__introBg");

    //現在のスクロール位置
    const scrollY = $(window).scrollTop();

    //位置を調整
    const wH = window.innerHeight;
    const wrapperH = wrapper.outerHeight();
    const bgH = bg.outerHeight();
    const bgAdjustRange = wrapperH - bgH;

    const minY = wrapper.offset().top - $(window).height();
    const maxY = wrapper.offset().top + wrapper.outerHeight() - $("header").outerHeight();

    let scrollRate = (scrollY - minY) / (maxY - minY);
    if(scrollRate < 0)
    {
      scrollRate = 0;
    }
    else if(scrollRate > 1)
    {
      scrollRate = 1;
    }
    TweenMax.set(bg, {y:bgAdjustRange*scrollRate});

    //inViewチェック
    if(!bg.hasClass("isInView"))
    {
      const topY = bg.offset().top - $("header").outerHeight() + bgH;
      const bottomY = bg.offset().top - wH;

      //INVIEW
      if(scrollY > bottomY && scrollY < topY)
      {
        bg.addClass("isInView");
        this.showIntroBg();
      }
    }

    //二つ目の画像を表示するかどうかの判定
    if(bg.hasClass("isInView"))
    {
      this.updateSecondeBg();
    }
  }

  showIntroBg(){
    const bg = $(".p-top__introBg");
    bg.addClass("showFirst");
  }

  /**
   * 2つ目の背景画像の表示制御
   */
  updateSecondeBg(){

    //参照
    const bg = $(".p-top__introBg");
    const en = $(".p-top__introContents").find(".en");

    //計算
    const scrollY = $(window).scrollTop();
    const wH = window.innerHeight;
    const hH = $("header").outerHeight();
    const centerY = hH + Math.floor((wH - hH)/2);
    const enY = en.offset().top - scrollY;

    //表示
    if(enY < centerY && !bg.hasClass("showLast"))
    {
      bg.addClass("showLast");
    }
    //非表示
    else if(enY > centerY && bg.hasClass("showLast"))
    {
      bg.removeClass("showLast");
    }
  }




  // ---------------------------------------------------------------------------------------------------------
	// --	WORKS一覧関連
	// ---------------------------------------------------------------------------------------------------------

  /**
   * アップデート
   */
  updateWorks(){
    const holder = this;
    $(".p-top__worksListItem").each(function(index){
      const item = $(this);
      if(!item.hasClass("isInit"))holder.initWorksItem(item);
      if(!item.hasClass("isInView"))holder.updateWorksItem(item);
    });
  }

  /**
   * 初期化
   */
  initWorksItem(item){

    //フラグをたてる
    item.addClass("isInit");

    //サブタイトルが無い時の処理
    if(!item.find(".subtitle").length)
    {
      const wrapper = item.find(".p-top__worksListItem-infoWrapper");
      wrapper.addClass("no-subtitle");
    }
  }

  /**
   * アップデート（inViewチェック）
   */
  updateWorksItem(item){

    //inViewチェック
    const scrollY = $(window).scrollTop();
    const topY = item.offset().top - $("header").outerHeight();
    const bottomY = item.offset().top - $(window).height() + item.outerHeight();

    //INVIEW
    if(scrollY > bottomY && scrollY < topY)
    {
      item.addClass("isInView");
      this.showWorksItem(item);
    }
  }

  /**
   * 表示
   */
  showWorksItem(item){
    const wrapper = item.find(".p-top__worksListItem-infoWrapper");
    wrapper.addClass("enter");
    TweenMax.delayedCall(0.6, ()=>{
      wrapper.addClass("show");
    });
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Top;
